import { render, staticRenderFns } from "./ManageCoa.vue?vue&type=template&id=56512be8&scoped=true"
import script from "./ManageCoa.vue?vue&type=script&lang=js"
export * from "./ManageCoa.vue?vue&type=script&lang=js"
import style0 from "./ManageCoa.vue?vue&type=style&index=0&id=56512be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56512be8",
  null
  
)

export default component.exports